import api from './api';

const campagnesMediasApi = {
  // Liste (filtres optionnels : concession_id, actif='1')
  getAll: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.concession_id) params.append('concession_id', filters.concession_id);
    if (filters.actif)         params.append('actif',         filters.actif);
    const qs = params.toString();
    return api.get(`/campagnes-medias${qs ? '?' + qs : ''}`);
  },

  // Campagnes actives à une date donnée (par défaut aujourd'hui)
  getActives: ({ date, concession_id } = {}) => {
    const params = new URLSearchParams();
    if (date)          params.append('date', date);
    if (concession_id) params.append('concession_id', concession_id);
    const qs = params.toString();
    return api.get(`/campagnes-medias/actives${qs ? '?' + qs : ''}`);
  },

  create: (data) => api.post('/campagnes-medias', data),
  update: (id, data) => api.put(`/campagnes-medias/${id}`, data),
  delete: (id) => api.delete(`/campagnes-medias/${id}`),

  // ── Nouveau modèle : campagnes dérivées des sujets de leads VN/VO ──
  // Référentiel des sujets (volumes + libellé normalisé éventuel)
  getSujets: ({ concession_id } = {}) => {
    const params = new URLSearchParams();
    if (concession_id) params.append('concession_id', concession_id);
    const qs = params.toString();
    return api.get(`/campagnes-medias/sujets${qs ? '?' + qs : ''}`);
  },
  // Enregistre les libellés normalisés : items = [{ sujet_brut, libelle }]
  saveSujets: (items) => api.put('/campagnes-medias/sujets', { items }),

  // Tableau de bord : total leads par campagne normalisée sur une plage de dates
  getDashboard: ({ debut, fin, concession_id } = {}) => {
    const params = new URLSearchParams();
    if (debut)         params.append('debut', debut);
    if (fin)           params.append('fin', fin);
    if (concession_id) params.append('concession_id', concession_id);
    const qs = params.toString();
    return api.get(`/campagnes-medias/dashboard${qs ? '?' + qs : ''}`);
  },
};

export default campagnesMediasApi;
